export default __webpack_public_path__ + "static/media/sweet-backed-apple.ebbdbcaa.jpeg";